import { mapping } from 'actions/mapping'
import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'shared/hooks'

import { useCurrent } from './current'

export function useLegacyAdapt() {
	const data = useAppSelector(state => state.campaign)
	const dispatch = useAppDispatch()
	const { campaign, id } = useCurrent()

	useEffect(() => {
		if (!campaign) {
			return
		}
		const payload = mapping.campaignTransform(campaign)

		dispatch({
			payload,
			type: 'CAMPAIGN'
		})
	}, [campaign, dispatch])

	return {
		data,
		isReady: id === data.id
	}
}
